export const DEFAULT_CLICK_ATTRIBUTION_WINDOW = '7d_click';
export const DEFAULT_VIEW_ATTRIBUTION_WINDOW = '1d_view';
export const CLICK_SUFFIX = '_click';
export const VIEW_SUFFIX = '_view';
export const DEFAULT_REPORT_TIME = 'mixed';
export const DEFAULT_AGGREGATION_LEVEL = 'ad';

export const AGGREGATION_LEVEL_NAMES = {
  ad: 'Ad ID',
  adset: 'Ad set ID',
  account: 'Account ID',
  campaign: 'Campaign ID'
};

export const DYNAMIC_CREATIVE_ASSET_SUPPORTED_FIELDS = [
  'impressions',
  'clicks',
  'spend',
  'reach',
  'actions',
  'action_values'
];

export const ATTRIBUTION_SETTINGS = {
  custom: 'use_custom_attribution_setting',
  account: 'use_account_attribution_setting',
  unified: 'use_unified_attribution_setting'
};

export const FB_LOGO_SRC =
  'https://res.cloudinary.com/hevo/image/upload/v1672294644/dashboard/fb-logo-thumb_dy9whp.svg';

export const FB_BREAKDOWNS_TO_IGNORE = [
  'app_id',
  'skan_conversion_id',
  'is_conversion_id_modeled',
  'skan_campaign_id',
  'mmm',
  'breakdown_reporting_ad_id',
  'is_rendered_as_delayed_skip_ad',
  'landing_destination',
  'media_type',
  'matched_persona_id',
  'matched_persona_name',
  "ad_extension_domain",
  "ad_extension_url",
  "breakdown_ad_objective",
  "comscore_market",
  "comscore_market_code",
  "creative_relaxation_asset_type",
  "flexible_format_asset_type",
  "gen_ai_asset_type",
  "impression_view_time_advertiser_hour_v2",
  "is_auto_advance",
  "sot_attribution_model_type",
  "sot_attribution_window",
  "sot_channel",
  "sot_event_type",
  "sot_source",
];